const getLoadedStatus = (rootState) => rootState.ws.view.status.loaded;

export default getLoadedStatus;
